<template>
  <div class="app-container">
    <div class="top_btns clearfix">
      <div class="left_box">
        <!-- <span style="">期间：</span> -->
        <qzf-period v-model:period="listQuery1.beginTime"></qzf-period>
          <span>-</span>
        <qzf-period v-model:period="listQuery1.endTime"></qzf-period>
        <!-- 悬浮导航 -->
        <h1 v-if="title" style="font-size: 16px;margin-bottom: 6px;display: inline-block;">
          {{title}}
          <el-button @click="getList2()" size="small">刷新</el-button>  
        </h1>
      </div>
      <!-- <div class="right_box">
        <el-dropdown size="small" style="margin-left:10px">
          <el-button size="small" type="primary">
            更多<el-icon class="el-icon--right"><arrow-down /></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="b">
                <span @click="daochu()">导出</span>
              </el-dropdown-item>
              <el-dropdown-item command="c">
                <span @click="printAll()">打印</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div> -->
    </div>
    <el-row>
      <el-col :span="5">
        <div class="searchGjz">
          <el-input v-model="listQuery.name" placeholder="请输入名称" style="width: 195px;margin-right: 10px;" size="small" @change="getList" />
          <selectInventoryType v-model:type="listQuery.type" @success="getList"></selectInventoryType>
          <el-tree ref="tree" class="elTree" :filter-node-method="filterNode" :data="data" :props="defaultProps" @node-click="handleNodeClick" @check="handleCheckChangeArea" node-key="id" style="width:100%;height:500px;overflow:scroll;box-shadow: rgb(219 211 211 / 58%) 2px 2px 7px 3px;"></el-tree>
        </div>
      </el-col>
      <el-col :span="19">
        <div>
          <div style="float:right;margin-bottom: 10px;">
            <el-button type="primary" size="small" @click="printExport('pdf')">打印</el-button>
            <el-button type="primary" size="small" @click="printExport('excel')">导出</el-button>
          </div>
          <el-table stripe :height="contentStyleObj" size="small" :header-cell-style="{background: '#eee',color:'#333','font-size': '13px'}" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 98%;margin-left: 25px;">
            <template #empty>
              <el-empty :image-size="150" description="没有数据"></el-empty>
            </template>
            <el-table-column label="名称" align="center" min-width="90">
            <template #default="scope">
              <el-tooltip v-if="scope.row.nowName" class="item" effect="dark" :content="scope.row.nowName" placement="top-start">
                <span>{{ scope.row.nowName }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column label="日期" align="center" min-width="90">
            <template #default="scope">
              <span>{{ scope.row.voucherDate }}</span>
            </template>
          </el-table-column> -->

          <el-table-column label="账期" align="center" min-width="90">
            <template #default="scope">
              <span>{{scope.row.period}}</span>
            </template>
          </el-table-column>

          <el-table-column label="业务类型" align="center" min-width="90">
            <template #default="scope">
              <!-- <span style="font-weight: bold;" v-if="scope.row.summary == '期初结存' || scope.row.summary == '本期合计' || scope.row.summary == '本年累计'">{{scope.row.summary}}</span> -->
              <span>{{scope.row.summary}}</span>
            </template>
          </el-table-column>
          <el-table-column label="入库" align="center">
            <el-table-column label="数量" width="90">
              <template #default="scope">
                <span v-if="scope.row.inCount">{{ scope.row.inCount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="90">
              <template #default="scope">
                <span v-if="scope.row.inPrice">{{ scope.row.inPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="inAmount" label="金额" width="110"></el-table-column>
          </el-table-column>
          <el-table-column label="出库" align="center">
            <el-table-column prop="outCount" label="数量" width="90"></el-table-column>
            <el-table-column prop="outPrice" label="单价" width="90"></el-table-column>
            <el-table-column prop="outAmount" label="金额" width="110"></el-table-column>
          </el-table-column>
          <el-table-column label="期末结存" align="center">
            <el-table-column prop="endCount" label="数量" width="90"></el-table-column>
            <el-table-column prop="endPrice" label="单价" width="90"></el-table-column>
            <el-table-column prop="endAmount" label="金额" width="110"></el-table-column>
          </el-table-column>
        </el-table>
        </div>
      </el-col>
    </el-row>
    <!-- <printVouch ref="printVouch" :name="this.name1" :listQuery1="this.listQuery" :DY="this.DY"></printVouch>
    <exportFile ref="exportFile" name="book_detail_account" :listQuery1="this.listQuery"></exportFile> -->
  </div>
</template>

<script>
import { inventoryList,getDetailAccountInverntoryList } from '@/api/inventory'
// import { bookDetailAccountList } from "@/api/book.js"
import { detailAccountInventoryOut } from '@/api/printSet'
import selectInventoryType from "./selectInventoryType.vue"
// import printVouch from "./printVouch.vue"
// import exportFile from "./exportFile.vue"
export default {
  name:'saleStock',
  components: { 
    // printVouch,exportFile
    selectInventoryType
    },
  data() {
    return {
      name1:'',
      DY: 0,
      contentStyleObj:{}, //高度变化
      formLabelWidth: '120px',
      filterText: '',
      // optionType: '1',
      listLoading: false,
      data:[],
      defaultProps: {
        children: 'children',
        label: 'name2',
      },
      list: [],
      listQuery: {
        name: '',
        type: 0
      },
      listQuery1: {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period:this.$store.getters['user/comInfo'].period,
        beginTime: '',
        endTime: '',
        id:undefined
      }
    }
  },
  created() {
    this.contentStyleObj=this.$getHeight(270)
    this.getList()
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
  },
  methods: {
    getList() {
      inventoryList(this.listQuery).then(res=>{
        this.data = res.data.data.list
        this.loading = false
      })
    },
    daochu(){
      this.$refs.exportFile.init()
    },
    printAll(e) {
      this.DY = e
      this.name1 = 'book_detail_account',
      this.$nextTick(()=>{
      this.$refs.printVouch.init()
      })
      
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name2.indexOf(value) !== -1
    },
    handleNodeClick(item) {
      this.listQuery1.id = Number(item.id)
      // this.listQuery.fzhsId = Number(item.fzhsItemId)
      this.listLoading = true
      getDetailAccountInverntoryList(this.listQuery1).then(res => {
        if(res.data.data.list) {
          this.list = res.data.data.list[0]
          this.listLoading = false
        }else {
          this.list = []
          this.listLoading = false
        }
      })
    },
    // 打印导出
    printExport(e){
      let param = {
        ids:this.listQuery1.id?[this.listQuery1.id]:[],
        type:e,
        startPeriod:this.listQuery1.beginTime,
        endPeriod:this.listQuery1.endTime
      }
      detailAccountInventoryOut(param).then(res => {
        if (res.data.msg == "success") {
          window.open(res.data.data.url); 
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.searchBtn {
  text-align: center;
  button {
    margin-right: 5px;
  }
}
.top_btns {
  margin-bottom: 20px;
  .left_box{
    float: left;
    width: 70%;
  }
  .right_box {
    float: right;
    width: 30%;
    text-align: right;
  }
}
.el-select {
  margin: 0 !important;
  width: 120px !important;
}
.elTree {
    width: 100%;
    height: 500px;
    overflow: scroll;
    // box-shadow: rgb(219 211 211 / 58%) 5px 8px 8px 3px;
    border: 1px solid #ede5e5;
    margin-top: 10px;
}
::-webkit-scrollbar {
    width: 8px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
    -webkit-box-shadow: rgba(0, 0, 0, 0.3);
    box-shadow: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(17, 16, 16, 0.13);
    -webkit-box-shadow: rgba(0, 0, 0, 0.9);
    box-shadow: rgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #efefef;
}
</style>